import Slider from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import useGetUserProfile from "../../hooks/useGetUserProfile";
import { useState } from "react";
import "../../styles/slider/activitySlider.scss";
import { displayNotImplemented } from "../../../../shared/services/Notifications/NotificationServices";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";


export default function ActivitySlider({username}:{username: string}) {

    const [activeCategory, setActiveCategory] = useState(0);
    const { data, isLoading, error } = useGetUserProfile(username, 'activity-log')

    const titles = [
        'Все',
        'Рейтинг',
        'Игры',
        'Команды',
        'Мероприятия',
        'Публикации',
    ]

    const handleCategoryClick = (index: number) => {
        if (index != 1 && index != 3 && index != 4 && index != 5) {
            setActiveCategory(index);
        } 
    }
    
    return (

        <div className="activity-swiper__container">
            <div className="activity-swiper__categories-container">
                {titles.map((title, index) => (
                    <div key={index} className="activity-swiper__category">
                        <button 
                            className={`activity-swiper__category-button ${index === activeCategory ? 'active' : ''}`}
                            onClick={() => handleCategoryClick(index)}
                        >
                            <p>{title}</p>
                        </button>
                    </div>
                ))}
            </div>
            
            <div className="activity-swiper__activities-container">
                <Swiper>
                    <div className="activity-swiper__activities-container-wrapper">
                        <SwiperSlide>
                        {data?.map((activity: any, index: any) => (
                            <div key={index} className="activity-swiper__activity">
                                <div className="activity-swiper__activity-info">
                                    <p className="activity-swiper__activity-date">{activity.event_date}</p>
                                    {activity.event_name && 
                                        <p className="activity-swiper__activity-title">{activity.event_name}</p>
                                    }
                                    {activity.role && 
                                        <p className="activity-swiper__activity-role">{activity.role}</p>
                                    }
                                    {/* Рейтинг */}

                                    {/*{activity.role && 
                                        <p className="activity-swiper__activity-rating">
                                            {activity.role} 
                                            <span className={`activity-swiper__activity-rating-change ${activity.ratingChange.includes('+') ? 'positive' : 'negative'}`}>
                                                {activity.ratingChange}
                                            </span>
                                        </p>
                                    } */}
                                    <button className="activity-swiper__activity-button" onClick={() => window.location.href = `/GameInfo/${activity.event_slug}`}>
                                        <p className="activity-swiper__activity-button-text">К игре</p> 
                                        <div className="activity-swiper__activity-arrow"></div>
                                    </button>
                                    
                                </div>
                                
                            </div>
                        ))}
                        </SwiperSlide>
                    </div>
                </Swiper>
            </div>
           
        </div>

    )
}